// ============================================================
// 現在ユーザーの主催団体 branding を保持するストア
//
// 主催者画面シェル(AdminLayout)が一度だけ取得し、テーマカラー/ロゴを
// 画面UI（ボタン・アクティブ状態・ヘッダーロゴ）へ反映するために使う。
// 設定画面でテーマ/ロゴを変更したら set() で即時同期する。
// 非主催者ユーザーや未取得時は branding=null → TAIARI 標準色にフォールバック。
// ============================================================

import { create } from 'zustand'
import { organizationsApi } from '@/services/api'
import type { OrganizationBranding } from '../../../shared/types'

interface OrgBrandingState {
  branding: OrganizationBranding | null
  status: 'idle' | 'loading' | 'loaded'
  /** 未取得なら一度だけ取得する（多重 fetch を避ける） */
  ensure: () => Promise<void>
  /** 強制再取得 */
  refresh: () => Promise<void>
  /** 設定保存後など、取得済み branding を即時差し替える */
  set: (branding: OrganizationBranding | null) => void
}

export const useOrgBrandingStore = create<OrgBrandingState>((set, get) => ({
  branding: null,
  status: 'idle',
  ensure: async () => {
    if (get().status !== 'idle') return
    await get().refresh()
  },
  refresh: async () => {
    set({ status: 'loading' })
    try {
      const orgs = await organizationsApi.getMyOrgs()
      set({ branding: orgs[0]?.branding ?? null, status: 'loaded' })
    } catch {
      // 取得失敗時は標準色のまま（白画面化させない）
      set({ branding: null, status: 'loaded' })
    }
  },
  set: (branding) => set({ branding }),
}))
